import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import queriesReducer from './queriesSlicer';
import type { LocationsState } from './queryModels';
import uiReducer from './uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    locations: queriesReducer,
    ui: uiReducer,
  },
});

export type RootState = {
  auth: ReturnType<typeof authReducer>;
  locations: LocationsState;
  ui: ReturnType<typeof uiReducer>;
};

export type AppDispatch = typeof store.dispatch;
